import { DBRecordStatus } from "../Common/CommonComponent";
import { ApiUtility } from "../Utilities/ApiUtility.axios";

class HolidaysService {
    route = `/Api/Holidays`;

    getUpdatesList = (start: number, length: any, search: string, status: DBRecordStatus, fromDate?: string, toDate?: string, sortCol?: any, sortDir?: any) =>
        ApiUtility.get(`${this.route}`, { start, length, search, status, fromDate, toDate, sortDir, sortCol });

    addUpdate = (id?: string, params?: any) => ApiUtility.post(`${this.route}/${id}`, params);

    deleteHoliday = (id: string) => ApiUtility.delete(`${this.route}/${id}/Delete`);

    toggleHolidayStatus = (id: string, status: DBRecordStatus) => ApiUtility.post(`${this.route}/${id}/ToggleStatus/${status}`, "");
}
export default new HolidaysService();